import React from 'react';

export const NoDataMessage = ({ 
    icon = "ri-inbox-line",
    message = "No data available",
    description = "Add some data to see the chart"
}) => {
    return (
        <div className="d-flex align-items-center justify-content-center h-100">
            <div className="text-center">
                <i className={`${icon} fs-48 text-gray-300 mb-3 d-block`}></i>
                <h6 className="fw-medium text-gray-600 mb-1">{message}</h6>
                <p className="text-gray-500 fs-sm mb-0">{description}</p>
            </div>
        </div>
    );
}; 